import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { useUser } from '@paintscout/ui-business'

/**
 * Guard component that redirects churned users to billing page
 * Only allows access to billing/settings routes when user is churned
 */
export default function ChurnedGuard({ children }: { children: React.ReactNode }) {
  const { isChurned, isSuperadmin, isSupport } = useUser()
  const location = useLocation()

  // Allow access to settings/billing routes when churned
  const isBillingRoute = location.pathname.startsWith('/settings')

  // If churned and not on billing route, redirect to billing
  // Superadmin and support bypass this block as they are internal staff
  if (isChurned && !isBillingRoute && !isSuperadmin && !isSupport) {
    return <Redirect to="/settings?section=billing-plan" />
  }

  return <>{children}</>
}
